import { Button, Tooltip, Typography, Card, CardContent, Grid } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { ProjectType } from '../../../models/project';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';

export const TimeAndMaterialForm = () => {
  const { control, watch, getValues } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'timeMaterials',
    keyName: 'itID',
  });
  const [projectType] = watch(['projectType']);

  const handleAddNew = () => {
    append({ timeMaterialWork: '' });
  };
  const handleRemove = (index: number) => {
    remove(index);
  };

  if (projectType === ProjectType.TimeAndMaterial) {
    return (
      <Card elevation={0}>
        <CardContent>
          <Grid container spacing={2}>
            {fields.map((field, index) => (
              <Grid item lg={11} sm={11} xl={11} xs={11} key={field.itID} className="inputaddItemBlock">
                <FormInput name={`timeMaterials.${index}.timeMaterialWork`} label="Inspection Title" />
                <FormInput
                  name={`timeMaterials.${index}.address`}
                  label="Address"
                  validationQueryRoute={(value: string) =>
                    projectsApiKeyStore.checkDuplicateLotAddress(getValues('projectID'), value)
                  }
                />
                <Button
                  className="btn btn-danger outlined "
                  variant="outlined"
                  aria-label="delete"
                  onClick={() => handleRemove(index)}
                >
                  <Tooltip title={<Typography variant="body1">Delete</Typography>}>
                    <DeleteIcon className="btnDelete" />
                  </Tooltip>
                </Button>
              </Grid>
            ))}
            <Grid item lg={1} sm={1} xl={1} xs={1}>
              <Button
                className="btn btn-primary btnIcon"
                variant="text"
                sx={{ p: 0, m: 0, mr: 1 }}
                onClick={handleAddNew}
              >
                <AddIcon />
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
  return null;
};
